import ProjectEditorDetail from "./Detail";
import Global from "components/common/Global";
import GuideLayout from "pages/project/editor/guide/Guide";
import CryptoJS from 'crypto-js';
import GuidesLayout from "./guide/Guides";

/** 编辑器库需要用到 */
window.CryptoJS = CryptoJS ;

export default function ProjectEditor(){
    return (
        <Global>
            <GuidesLayout>
                <ProjectEditorDetail />
            </GuidesLayout>
        </Global>
    )
}